import * as React from "react"

import { Action, ActionAnchor } from "@tenforce/toolbox-button-push-react"
import { Symbols } from "@tenforce/toolbox-fontmap"

import { Labels } from "../../../util/Translations"

interface Props {
    helpUrl: string
    showDictionary: () => void
    supportMailAddress: string
}

interface State {
    top: string
}

export default class BottomBar extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            top: "0",
        }
    }

    onSizeChanged = (): void => {
        const innerHeight = window.innerHeight
        // the 50 is the minimum distance we want to be from the bottom of the window
        this.setState({
            top: `${window.scrollY + innerHeight - 50}px`,
        })
    }

    componentDidMount(): void {
        window.addEventListener("resize", this.onSizeChanged)
        document.addEventListener("scroll", this.onSizeChanged)
        this.onSizeChanged()
    }

    componentWillUnmount(): void {
        window.removeEventListener("resize", this.onSizeChanged)
        document.removeEventListener("scroll", this.onSizeChanged)
    }

    render(): JSX.Element {
        const { top } = this.state
        const { helpUrl, showDictionary, supportMailAddress } = this.props
        const { ContactSupport, Dictionary, FullDocumentation } = Labels

        const isHelpVisible = helpUrl.length > 0
        const isSupportLinkVisible = supportMailAddress.length > 0

        return (
            <div
                style={{
                    top,
                    left: "50%",
                    position: "absolute",
                    transform: "translateX(-50%)",
                }}
                className="tw-flex"
            >
                <div className="bg-white tw-rounded-full tw-px-4 tw-py-2 tw-mx-2">
                    <Action
                        onClick={showDictionary}
                        data-ft-component="dictionary-button"
                        extraClasses="text-black"
                    >
                        {Symbols.OpenBook}&nbsp;
                        <span className="theme-link">{Dictionary}</span>
                    </Action>
                </div>

                <div className="bg-white tw-rounded-full tw-px-4 tw-py-2 tw-mx-2">
                    {isHelpVisible && (
                        <ActionAnchor
                            extraClasses="text-black"
                            href={helpUrl}
                            target="_blank"
                            data-ft-component="documentation-link"
                        >
                            {Symbols.Instructions}&nbsp;
                            <span className="theme-link">
                                {FullDocumentation}
                            </span>
                        </ActionAnchor>
                    )}

                    {isHelpVisible && isSupportLinkVisible && (
                        <div className="separator"></div>
                    )}

                    {isSupportLinkVisible && (
                        <ActionAnchor
                            extraClasses="text-black"
                            href={`mailto:${supportMailAddress}`}
                            target="_blank"
                            data-ft-component="support-mail"
                        >
                            {Symbols.Email}&nbsp;
                            <span className="theme-link">{ContactSupport}</span>
                        </ActionAnchor>
                    )}
                </div>
            </div>
        )
    }
}
